import styled from 'styled-components';
import { Button } from '@perch-labs/shrike';

export const ButtonChip = styled(Button)<StyleProps>`
  && {
    font-size: ${props => props.theme.fontSizes[400]};
    width: initial;
    padding: 8px 16px;
    border-radius: 16px;
    margin: 0 4px 4px 0;
    color: ${props =>
      props.active ? 'white' : props.theme.colors.content.primary};
    background: ${props =>
      props.active
        ? props.theme.colors.background.primaryInverse
        : props.theme.colors.background.secondary};
  }
`;
